module.exports = __webpack_public_path__ + "img/logoBolden.d9031409.png";